module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-8.750db097.jpg";